'use client';

import React, { useState, useId } from 'react';
import { useLocale, useTranslations } from 'next-intl';
import { getHrefLang } from '@/widgets/MainLayout/utils/getHrefLang';
import { Link, usePathname } from '@/navigation';
import { languages, languageLabels, LangCodeByCountry } from '@/shared/config/common/constants/lang';
import type { LanguageCodeEnum } from '@/shared/config/common/constants/lang';
import { classNames } from '@/shared/lib/classnames/classnames';
import btnIcons from '@/shared/assets/sprites/btns.sprite.svg';
export const DesktopLanguageSelector: React.FC = () => {
  const currentLocale = useLocale();
  const t = useTranslations('doctor.language_selector');
  const pathname = usePathname();
  const listboxId = useId();
  const buttonId = useId();
  const [openedSelect, setOpenedSelect] = useState<boolean>(false);
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Escape') {
      setOpenedSelect(false);
    } else if (event.key === 'Enter' || event.key === ' ') {
      setOpenedSelect(prev => !prev);
    }
  };
  return <div className={classNames('relative hidden cursor-pointer select-none rounded-3xl bg-bgSecondary px-2 py-1 lg:block', {
    'rounded-b-none rounded-t-xl': openedSelect
  })} data-sentry-component="DesktopLanguageSelector" data-sentry-source-file="DesktopLanguageSelector.tsx">
      <button id={buttonId} aria-haspopup="listbox" aria-expanded={openedSelect} aria-controls={listboxId} aria-label={t('aria_label_button')} onClick={() => setOpenedSelect(prev => !prev)} onKeyDown={handleKeyDown} className="flex w-full items-center gap-1">
        <span>{languageLabels[currentLocale as LanguageCodeEnum]}</span>
        <span className="flex size-4 items-center justify-center" aria-hidden="true">
          <svg className="h-2.5 w-1.5 rotate-90 stroke-textPrimary stroke-1.5" data-sentry-element="svg" data-sentry-source-file="DesktopLanguageSelector.tsx">
            <use xlinkHref={`${btnIcons}#arrow`} data-sentry-element="use" data-sentry-source-file="DesktopLanguageSelector.tsx"></use>
          </svg>
        </span>
      </button>

      {openedSelect && <div id={listboxId} role="listbox" aria-label={t('aria_label_listbox')} className={classNames('absolute left-0 top-full flex w-full flex-col rounded-xl bg-bgSecondary', {
      'rounded-t-none': openedSelect
    })}>
          {languages.filter(lang => lang.code !== currentLocale).map(lang => {
        return <Link key={lang.code} href={getHrefLang(lang.code, pathname)} hrefLang={LangCodeByCountry[lang.code]} role="option" aria-selected="false" aria-label={t('aria_label_option', {
          language: languageLabels[lang.code]
        })} className="border border-b-black pl-2 transition-colors last:border-none">
                  {lang.label}
                </Link>;
      })}
        </div>}
    </div>;
};